<script>
    import ClickCall from '../../mixins/ClickCall.vue';
    export default {
        mixins: [ClickCall],
        methods: {
            success() {
                window.location.reload(true);
            },
        }
    }
</script>